import { Users, Building2, Shield, ShieldCheck, Receipt, Palmtree, Calendar, Package, ClipboardList, CalendarClock, LayoutDashboard, Link2, Clock, Megaphone, Utensils, GraduationCap, Gift, Ticket, Activity, UserSearch, Sparkles, Rocket, LogOut, IdCard, Target, UserCircle, CheckCircle2, Briefcase, Heart, Settings, Star, BarChart3, SlidersHorizontal, ScrollText, Key, Plug, KeyRound, Globe } from 'lucide-react';

// Benim grubu (self-servis) — çocuk literalleri ilgili modüllerden taşındı;
// path/privileges/moduleGated korunur, yalnızca üst grup değişti.
const benim = {
  key: 'benim', labelKey: 'menu.myArea', icon: UserCircle, variant: 'pinned', privileges: [],
  children: [
    { key: 'my-leaves', labelKey: 'menu.myLeaves', path: '/my-leaves', module: 'LM', privileges: [] },
    // Takvimim (spec 2026-10-30) — resmî tatiller + kendi onaylı/bekleyen izinleri tek yıllık takvimde. `module`
    // YOK: resmî tatiller her şirkette görünür; izin katmanlarını sayfa kendi LM kapısıyla gösterir.
    { key: 'my-calendar', labelKey: 'menu.myCalendar', path: '/my-calendar', privileges: [] },
    // Ekibimin İzinleri (spec 2026-10-31) — ekibin bugünkü ve 1 yıllık onaylı/bekleyen izinleri. LM.Read GEREKMEZ
    // (satın alınan modülde yalnız rolle gelir); kapı module: 'LM' → hasModule && hasSeat. Ekip sunucuda çözülür.
    { key: 'my-team-leaves', labelKey: 'menu.myTeamLeaves', path: '/my-team-leaves', module: 'LM', privileges: [] },
    // Excel ile toplu izin girişi: amir kendi astları, LM.Write'lı İK tüm şirket için
    // (backend LeaveImportController.IsPrivileged). OR-kapısı — LM.Write VEYA astı olmak;
    // ikisi de yoksa gizli. `requiresUserFlag` (AND) KULLANILMAZ: superAdmin istisnasından
    // önce çalıştığı için astı olmayan İK'dan menüyü gizliyordu, oysa başka sistemden
    // geçişte geçmiş izinler bu ekrandan yüklenir (Devir Bakiyesi şablonunun Yardım'ı).
    { key: 'team-leave-import', labelKey: 'menu.teamLeaveImport', path: '/team-leave-import', module: 'LM', privileges: ['LM.Write'], orUserFlag: 'hasSubordinates' },
    // Organizasyon Şeması (spec 2026-10-15) — her çalışana açık, salt okunur şirket şeması; yönetici kendi alt dalında
    // boş/ayrılan koltukları ve kadro talebini, EM.Write "Düzenle" kipini görür. `privileges: []` ve `module` YOK:
    // şema modülden bağımsız (EM varsayılan), görünürlük sunucuda çözülür. Eski "Ekibimin Şeması"nın yerindedir.
    { key: 'org-chart', labelKey: 'menu.orgChart', path: '/org-chart', privileges: [] },
    { key: 'my-expenses', labelKey: 'menu.myExpenses', path: '/my-expenses', module: 'EX', privileges: [] },
    { key: 'my-attendance', labelKey: 'menu.myAttendance', path: '/my-attendance', module: 'TA', privileges: [] },
    // Task 11 (Özlük Dosyası, koordinatör incelemesi düzeltmesi) — Belgelerim: çalışanın kendi
    // özlük dosyası self-servisi (kimlik kartı, diploma, iş sözleşmesi vb.) — idari bir self-
    // servis, "Gelişimim" (eğitim/hedef/yetkinlik) alt-grubuna DEĞİL, my-leaves/my-expenses/
    // my-attendance ile AYNI üst-seviye konuma oturur. `module` alanı KONMAZ — self-servis
    // uçlar modül kilidi almaz (personnel-files backend'i EM.Write olmayan çağırana yalnız
    // kendi dosyasını döner).
    { key: 'my-documents', labelKey: 'menu.myDocuments', path: '/my-documents', privileges: [] },
    // KVKK md. 7/11 self-servis: rıza görme/geri çekme. `module` YOK — ilgili-kişi hakları
    // modül aboneliğine bağlanamaz (backend uçları da modül kapısızdır).
    { key: 'my-consents', labelKey: 'menu.myConsents', path: '/my-consents', privileges: [] },
    // KVKK md. 11 başvurusu (silme/düzeltme/bilgi). Aynı gerekçeyle `module` YOK.
    { key: 'my-kvkk-requests', labelKey: 'menu.myKvkkRequests', path: '/my-kvkk-requests', privileges: [] },
    { key: 'my-schedule', labelKey: 'menu.mySchedule', path: '/my-schedule', module: 'SM', privileges: [] },
    { key: 'my-shift-swaps', labelKey: 'menu.myShiftSwaps', path: '/my-shift-swaps', module: 'SM', privileges: [] },
    // Task 31 (Sürekli Geri Bildirim) — gönderim tek-seferlik bir aksiyon
    // sayfası, "Gelişimim" gibi bir listeleme alt-grubuna değil, my-leaves/
    // my-expenses/my-attendance/my-schedule ile AYNI üst-seviye desene
    // (tekil self-servis leaf + açık `module` alanı) oturur.
    // P2 Faz 1 — tüm bekleyen PM/TD işleri tek ekranda.
    // `badge` alanı SidebarMenu'de bekleyen iş sayacına bağlanır (spec §Bileşen 3).
    { key: 'performance-inbox', labelKey: 'menu.performanceInbox', path: '/performance/inbox', module: 'PM', privileges: [], badge: 'performanceInbox' },
    // PM analitik Faz 2 Plan 5-6 (spec §8-§10) — çalışma alanları. Performans grubu PM.Read ya da astı istediği için self-servis
    // "Performansım" (PM koltuklu herkes) ve yöneticinin "Ekibimin Performansı" burada, Gelen Kutum'un hemen altında.
    { key: 'performance-me', labelKey: 'menu.performanceMe', path: '/performance/me', module: 'PM', privileges: [] },
    { key: 'performance-team', labelKey: 'menu.performanceTeam', path: '/performance/team', module: 'PM', privileges: [], requiresUserFlag: 'hasSubordinates' },
    { key: 'feedback-send', labelKey: 'menu.sendFeedback', path: '/feedback/send', module: 'PM', privileges: [] },
    { key: 'benim-gelisim', labelKey: 'menu.myDevelopment', children: [
      { key: 'my-trainings', labelKey: 'menu.myTrainings', path: '/my-trainings', module: 'TR', privileges: ['TR.Read'] },
      { key: 'my-certificates', labelKey: 'menu.myCertificates', path: '/my-certificates', module: 'TR', privileges: ['TR.Read'] },
      { key: 'my-badges', labelKey: 'menu.myBadges', path: '/my-badges', module: 'TR', privileges: ['TR.Read'] },
      { key: 'my-certifications', labelKey: 'menu.myCertifications', path: '/my-certifications', privileges: [] },
      { key: 'performance-my-goals', labelKey: 'menu.myGoals', path: '/performance/my-goals', module: 'PM', privileges: [] },
      // Task 37 cutover: eski self-servis "Değerlendirmelerim" hedefi
      // (/performance/my-reviews, eski akran değerlendirme sistemi) PRD 360°
      // "bekleyen formlarım" sayfasına (/performance/fill-feedback) devrediyor.
      // Aynı etiket korunur — eski rota Task 38'e dek canlı kalır, menüden
      // yalnızca bu giriş çıkarılır (doğrudan URL ile erişilebilir durumda).
      { key: 'performance-fill-feedback', labelKey: 'menu.myReviews', path: '/performance/fill-feedback', module: 'PM', privileges: [] },
      { key: 'performance-my-evaluators', labelKey: 'menu.myEvaluators', path: '/performance/my-evaluators', module: 'PM', privileges: [] },
      { key: 'performance-my-results', labelKey: 'menu.myPeriodResults', path: '/performance/my-results', module: 'PM', privileges: [] },
      { key: 'performance-my-calibration', labelKey: 'menu.myCalibration', path: '/performance/my-calibration', module: 'PM', privileges: [] },
      // P1 — çalışanın kendi PIP süreci (salt-okunur; yalnız active/completed görünür).
      { key: 'my-pip', labelKey: 'menu.myPip', path: '/my-pip', module: 'PM', privileges: [] },
      { key: 'feedback-my', labelKey: 'menu.myFeedback', path: '/feedback/my', module: 'PM', privileges: [] },
      // F2 düzeltmesi (whole-branch review, Fix round 2) — 1:1 Görüşmelerim
      // + Takdir "Performans Yönetimi" grubundan (PM.Read kapılı) BURAYA
      // taşındı: ikisi de self-servis yüzey (doğrudan yönetici/katılımcı +
      // herhangi bir çalışan takdir gönderebilir/duvarı görebilir), PM.Read
      // ayrıcalığı GEREKTİRMEZ — asıl hedef kitle (PM.Read'i OLMAYAN sıradan
      // çalışan) önceki konumda sayfaya menüden hiç erişemiyordu. Konum
      // gereği eski `module:'PM', privileges:['PM.Read']` PM Yönetimi
      // grubundaki komşularının deseniydi; feedback-my ile AYNI self-servis
      // desene (`module:'PM', privileges:[]`) çekildi — sayfa/route içeriği
      // DEĞİŞMEDİ, yalnız menü konumu+kapı.
      { key: 'performance-one-on-ones', labelKey: 'menu.oneOnOnes', path: '/performance/one-on-ones', module: 'PM', privileges: [] },
      { key: 'performance-recognitions', labelKey: 'menu.recognitions', path: '/performance/recognitions', module: 'PM', privileges: [] },
      // TD-C — `requiresUserFlag`: kiracı ayarı (TalentSettings.EmployeeCanSeeNineBox,
      // varsayılan KAPALI) açık değilse girdi HİÇ çizilmez. Önceden yalnız `module: 'TD'`
      // vardı: TD abonesi her kiracıda 1200 çalışan menüde "9-Kutum" görüyor, tıklıyor ve
      // backend'in 409 talent.ninebox.selfViewDisabled'ı yüzünden kalıcı boş sayfaya
      // düşüyordu ("İşten Ayrılışım" ile AYNI koşullu-menü deseni).
      { key: 'talent-my-ninebox', labelKey: 'menu.myNineBox', path: '/talent/my-ninebox', module: 'TD', privileges: [], requiresUserFlag: 'canSeeNineBox' },
      { key: 'performance-my-idp', labelKey: 'menu.myDevelopmentPlans', path: '/talent/my-development-plans', module: 'TD', privileges: [] },
      { key: 'my-resume', labelKey: 'menu.myResume', path: '/my-resume', privileges: [] },
    ]},
    { key: 'benim-yanhak', labelKey: 'menu.myBenefitsGroup', children: [
      { key: 'my-benefits', labelKey: 'menu.myBenefits', path: '/my-benefits', module: 'BN', privileges: [] },
      { key: 'my-benefit-applications', labelKey: 'menu.myBenefitApplications', path: '/my-benefit-applications', module: 'BN', privileges: [] },
    ]},
    { key: 'benim-diger', labelKey: 'menu.myOther', children: [
      { key: 'my-assets', labelKey: 'menu.myAssets', path: '/my-assets', module: 'AM', privileges: [] },
      { key: 'my-timesheet-sm', labelKey: 'menu.myTimesheet', path: '/my-timesheet', module: 'SM', privileges: [] },
      { key: 'my-surveys', labelKey: 'menu.mySurveys', path: '/my-surveys', module: 'SV', privileges: [] },
      // `['CN.Read']` idi: menü "Benim/Diğer" grubunda self-servis olarak duruyor
      // ama sayfanın çağırdığı üç uç yönetim controller'larının CN.Read kapısı
      // altındaydı — CN'e abone 12 kiracıdaki 755 kullanıcının 754'ünde menü
      // ya hiç çıkmıyordu. Uçlar MyMealController'a ayrıldıktan sonra kapı
      // komşularıyla (my-surveys/my-visits/my-assets) aynı desene çekildi:
      // izin DEĞİL, kiracı aboneliği.
      { key: 'my-meals', labelKey: 'menu.myMeals', path: '/my-meals', module: 'CN', privileges: [] },
      // AKM POC §7.1 — büyük raporlar arka planda hazırlanır; isteyen buradan 7 gün indirir (modül kapısı yok).
      { key: 'my-exports', labelKey: 'menu.myExports', path: '/my-exports', privileges: [] },
      { key: 'my-visits', labelKey: 'menu.myVisits', path: '/my-visits', module: 'VM', privileges: [] },
      { key: 'my-announcements', labelKey: 'menu.myAnnouncements', path: '/my-announcements', privileges: ['AN.Read'] },
      { key: 'my-raffles', labelKey: 'menu.myRaffles', path: '/my-raffles', privileges: ['RF.Read'] },
      { key: 'my-links', labelKey: 'menu.myLinks', path: '/my-links', privileges: [] },
      { key: 'my-policy-tasks', labelKey: 'menu.myPolicyTasks', path: '/my-policy-tasks', module: 'ET', privileges: ['ET.Read'] },
      { key: 'my-ethics-reports', labelKey: 'menu.myEthicsReports', path: '/my-ethics-reports', module: 'ET', privileges: ['ET.Read'] },
    ]},
  ],
};

// Onaylarım artık bir menü GRUBU değil, tek panel sayfası: dokuz onay
// kategorisi kart olarak /approvals'ta duruyor. Sekiz ROTA yerinde kalır
// (panel kartları ve doğrudan URL ile erişilir), yalnız menüden çıkarlar.
// Görünürlük (hiç onay kategorisi yoksa öğe hiç çizilmez) SidebarMenu.hasAccess
// içinde hasAnyApprovalCategory ile kontrol edilir — burada privileges: []
// olması bilinçli (herkes görebilir gibi görünse de gerçek kapı hasAccess'te).
const onaylarim = {
  key: 'onaylarim', labelKey: 'menu.myApprovals', icon: CheckCircle2,
  variant: 'pinned', path: '/approvals', privileges: [], badge: 'approvals',
};

const menuConfig = [
  {
    key: 'dashboard',
    labelKey: 'menu.dashboard',
    icon: LayoutDashboard,
    path: '/',
    privileges: [],
  },
  benim,
  onaylarim,
  {
    key: 'employee-management',
    labelKey: 'menu.employeeManagement',
    icon: Users,
    variant: 'pinned',
    privileges: ['EM.Read'],
    children: [
      {
        key: 'employees',
        labelKey: 'menu.employees',
        path: '/employees',
        privileges: ['EM.Read'],
      },
      {
        // KVKK md. 11 başvurularını (silme / düzeltme / bilgi) inceleyen İK yüzü. EM varsayılan
        // modül: her kiracıda açık ve herkes EM.Read taşır → EM.Write (backend sınıf düzeyinde
        // aynı). moduleGated YOK: enterpriseAdmin EM.Write'ı kapsar ve görmelidir (kardeş
        // assignment-failures / personnel-files ile aynı).
        key: 'kvkk-requests',
        labelKey: 'menu.kvkkRequests',
        path: '/kvkk-requests',
        privileges: ['EM.Write'],
      },
      {
        key: 'probation-reviews',
        labelKey: 'menu.probationReviews',
        path: '/probation-reviews',
        // GÜVENLİK (2026-10-04): YÖNETİM ekranı (oluştur / sonuçlandır / iptal). EM VARSAYILAN
        // modül → EM.Read HERKESTE var; EM.Write ister (BE de listeyi EM.Write olmayana
        // kendi kaydına daraltır — kardeş employee-documents ile aynı).
        privileges: ['EM.Write'],
      },
      {
        key: 'assignment-failures',
        labelKey: 'menu.assignmentFailures',
        path: '/assignment-failures',
        // Tamamlanamayan otomatik atamalar (DLQ). Yönetim ekranı → EM.Write
        // (EM varsayılan modül olduğu için EM.Read herkeste var).
        privileges: ['EM.Write'],
      },
      {
        key: 'personnel-files',
        labelKey: 'menu.personnelFiles',
        path: '/personnel-files',
        // Adaylıktan ayrılışa tüm belgeleri birleştiren kişi-bazlı görünüm. Yönetim ekranı →
        // EM.Write (EM varsayılan modül olduğu için EM.Read herkeste var).
        privileges: ['EM.Write'],
      },
      {
        key: 'employee-documents',
        labelKey: 'menu.employeeDocuments',
        path: '/employee-documents',
        // GÜVENLİK (2026-08-11): EM VARSAYILAN modül olduğundan EM.Read HERKESTE var —
        // bu bir YÖNETİM ekranı, EM.Write ister (BE de listeyi buna göre daraltır).
        privileges: ['EM.Write'],
      },
      {
        key: 'certification-categories',
        labelKey: 'menu.certificationCategories',
        path: '/certifications/categories',
        privileges: ['EM.Write'],
      },
      {
        key: 'import',
        labelKey: 'menu.import',
        path: '/import',
        privileges: ['EM.Write'],
      },
      {
        // Toplu profil fotoğrafı (2026-10-19): dosya adı sicil no / kurumsal e-posta olan fotoğraflar.
        key: 'employee-photo-import',
        labelKey: 'menu.employeePhotoImport',
        path: '/employee-photo-import',
        privileges: ['EM.Write'],
      },
      {
        key: 'employee-reports',
        labelKey: 'menu.employeeReports',
        path: '/employee-reports',
        privileges: ['EM.Write'],
      },
      {
        key: 'employee-numbering-settings',
        labelKey: 'menu.employeeNumberingSettings',
        path: '/employee-numbering-settings',
        privileges: ['EM.Write'],
      },
    ],
  },
  // Task 16 (HR Analytics Plan 1) — tek sayfalı Genel Bakış (Veri Hazırlık Skoru +
  // Metrik Kataloğu). Employee Management gibi hiçbir yaşam döngüsü aşamasına
  // bağlı olmayan, tüm modüllerden okuyan çapraz-kesit bir yüzey olduğu için
  // kategorilerin dışında, üst seviyede duruyor. moduleGated: true zorunlu —
  // aksi halde enterpriseAdmin, HA'ya abone olmayan tenant'ta menüyü görür.
  //
  // Task 16 (HR Analytics Plan 2) — Karşılaştırma (funnel plot, Task 14) ve Devir & Kohort
  // (Kaplan-Meier, Task 15) sayfaları eklenince tek yaprak bir gruba dönüştü — diğer tüm
  // moduleGated modüllerle (expense-management/training/vb.) AYNI desen: PARENT'ın kendi
  // path'i YOK, ilk çocuk eski `/hr-analytics` yolunu (Genel Bakış) devralıyor. moduleGated
  // yalnız PARENT'ta kalır (children kendi moduleGated'ini taşımaz — leave-management/
  // training grupları ile AYNI emsal); tenant'ın HA aboneliği yoksa filterAccessible tüm
  // grubu (children'larıyla birlikte) tek seferde düşürür.
  // Task 12 (HR Analytics Plan 3) — Erken Uyarılar (HaAlertsController + kanıt paneli, Task 10)
  // ve Ayarlar (KVKK uyumlu bireysel skorlama opt-in ekranı, Task 11) eklendi; grup artık 5
  // çocuklu. Etiketler kendi sayfalarının başlığıyla (hrAnalytics.alerts.pageTitle /
  // hrAnalytics.settings.pageTitle) BİREBİR aynı — Genel Bakış'ın hrAnalytics.overview ile
  // paylaştığı AYNI emsal.
  {
    key: 'hrAnalytics',
    labelKey: 'menu.hrAnalytics',
    icon: BarChart3,
    privileges: ['HA.Read', 'HA.Write'],
    moduleGated: true,
    children: [
      // Analiz Paneli EN ÜSTTE (2026-08-03 kullanıcı kararı): modülün görsel vitrini.
      { key: 'hr-analytics-dashboard', labelKey: 'menu.hrAnalyticsDashboard', path: '/hr-analytics/dashboard', privileges: ['HA.Read', 'HA.Write'] },
      { key: 'hr-analytics-overview', labelKey: 'menu.hrAnalyticsOverview', path: '/hr-analytics', privileges: ['HA.Read', 'HA.Write'] },
      // Karşılaştırma (funnel) 2026-08-03'te Devir ve Kohort sayfasına taşındı — ayrı menü
      // kalemi kaldırıldı, eski rota routes/index.js'te Redirect olarak yaşıyor.
      { key: 'hr-analytics-turnover', labelKey: 'menu.hrAnalyticsTurnover', path: '/hr-analytics/turnover', privileges: ['HA.Read', 'HA.Write'] },
      // İşe Alım Raporu — ATS ailesinin sekiz metriği + XLSX. AT aboneliğine göre AYRICA
      // gizlenmez: metrik kilitliyse sayfa bunu gerekçesiyle söyler (katalogla AYNI davranış),
      // menüyü AT'ye bağlamak "HA aldım ama raporu göremiyorum" sessizliği üretirdi.
      { key: 'hr-analytics-recruiting', labelKey: 'menu.hrAnalyticsRecruiting', path: '/hr-analytics/recruiting', privileges: ['HA.Read', 'HA.Write'] },
      { key: 'hr-analytics-alerts', labelKey: 'menu.hrAnalyticsAlerts', path: '/hr-analytics/alerts', privileges: ['HA.Read', 'HA.Write'] },
      { key: 'hr-analytics-insights', labelKey: 'menu.hrAnalyticsInsights', path: '/hr-analytics/insights', privileges: ['HA.Read', 'HA.Write'] },
      { key: 'hr-analytics-settings', labelKey: 'menu.hrAnalyticsSettings', path: '/hr-analytics/settings', privileges: ['HA.Read', 'HA.Write'] },
    ],
  },
  // ---- Zaman & Devam kategorisi ----
  {
    key: 'cat-zaman',
    labelKey: 'menu.catTimeAttendance',
    icon: Clock,
    variant: 'category',
    privileges: [],
    children: [
      {
        key: 'leave-management',
        labelKey: 'menu.leaveManagement',
        icon: Palmtree,
        privileges: ['LM.Read'],
        moduleGated: true,
        children: [
          { key: 'leave-dashboard', labelKey: 'menu.leaveDashboard', path: '/leave-dashboard', privileges: ['LM.Write'] },
          { key: 'all-leaves', labelKey: 'menu.allLeaves', path: '/all-leaves', privileges: ['LM.Write'] },
          { key: 'leave-types', labelKey: 'menu.leaveTypes', path: '/leave-types', privileges: ['LM.Write'] },
          { key: 'leave-policies', labelKey: 'menu.leavePolicies', path: '/leave-policies', privileges: ['LM.Write'] },
          { key: 'bulk-leaves', labelKey: 'menu.bulkLeaves', path: '/bulk-leaves', privileges: ['LM.Write'] },
          // İzin Bakiye Raporu: LM.Write olan İK tüm tenantı, astı olan amir yalnız
          // ekibini görür (kapsam backend'de, LeaveScopeResolver). privileges boş —
          // görünürlük SidebarMenu.hasAccess'teki özel dalda (canWrite('LM') ||
          // hasSubordinates); requiresUserFlag TEK BAŞINA yanlış olurdu: astsız İK
          // kullanıcısından menüyü gizlerdi.
          { key: 'leave-balance-report', labelKey: 'menu.leaveBalanceReport', path: '/leave-balance-report', privileges: [] },
          // Devir Bakiyesi: başka bir sistemden geçişte kullanılan İK kurulum
          // ekranı. Bir kişinin bakiyesini doğrudan büyütebildiği için amir
          // yolu YOK — leave-policies ile aynı LM.Write kapısı.
          { key: 'leave-opening-balance', labelKey: 'menu.leaveOpeningBalance', path: '/leave-opening-balance', privileges: ['LM.Write'] },
          // Ek İzin Bakiyesi — İK'nın yıllık izin bakiyesine kural dışı gün eklemesi (elle +
          // Excel). Devir bakiyesi gibi bir kişinin bakiyesini doğrudan büyütür: amir yolu
          // YOK, aynı LM.Write kapısı (backend de her uçta LM.Write ister).
          { key: 'leave-extra-balance', labelKey: 'menu.leaveExtraBalance', path: '/leave-extra-balance', privileges: ['LM.Write'] },
          // Yıl Sonu İzin Mutabakatı (Görev 12) — İK takip yüzeyi: liste LM.Read ile
          // görünür (Teslim Al/Geri Al aksiyonları LM.Write, sayfa içinde canWrite('LM')
          // ile ayrıca daralır — backend de Deliver/Revoke'ta [ModuleAuthorize("LM","Write")]
          // ister). Kardeşlerinin çoğu (leave-management'ın kendisi zaten moduleGated)
          // ayrıca moduleGated TAŞIMAZ (bkz. dosya başındaki "children kendi moduleGated'ini
          // taşımaz" notu); bu öğede brief'in açık isteği üzerine BİLİNÇLİ OLARAK var —
          // parça üstündeki gate'le yedekli ama zararsız (moduleGateCode ikisinde de 'LM').
          { key: 'leave-reconciliations', labelKey: 'menu.leaveReconciliations', path: '/leave-reconciliations', privileges: ['LM.Read'], moduleGated: true },
        ],
      },
      {
        key: 'time-attendance',
        labelKey: 'menu.timeAttendance',
        icon: Clock,
        privileges: ['TA.Read'],
        moduleGated: true,
        children: [
          { key: 'pdks-dashboard', labelKey: 'menu.pdksDashboard', path: '/pdks-dashboard', privileges: ['TA.Read'], moduleGated: true },
          { key: 'puantaj', labelKey: 'menu.puantaj', path: '/puantaj', privileges: ['TA.Read'], moduleGated: true },
          { key: 'missing-records', labelKey: 'menu.missingRecords', path: '/missing-records', privileges: ['TA.Read'], moduleGated: true },
          { key: 'tardiness-report', labelKey: 'menu.tardinessReport', path: '/pdks-reports/tardiness', privileges: ['TA.Read'], moduleGated: true },
          { key: 'absenteeism-report', labelKey: 'menu.absenteeismReport', path: '/pdks-reports/absenteeism', privileges: ['TA.Read'], moduleGated: true },
          { key: 'early-departure-report', labelKey: 'menu.earlyDepartureReport', path: '/pdks-reports/early-departure', privileges: ['TA.Read'], moduleGated: true },
          { key: 'overtime-report', labelKey: 'menu.overtimeReport', path: '/pdks-reports/overtime', privileges: ['TA.Read'], moduleGated: true },
          { key: 'exceptions-report', labelKey: 'menu.exceptionsReport', path: '/pdks-reports/exceptions', privileges: ['TA.Read'], moduleGated: true },
          // AKM POC §7.4 — Eksik Çalışanlar (Devam Paneli'nden de açılır).
          { key: 'undertime-report', labelKey: 'menu.undertimeReport', path: '/pdks-reports/undertime', privileges: ['TA.Read'], moduleGated: true },
          // AKM POC §7.2/§7.4 — yeni PDKS raporları.
          { key: 'attendance-card', labelKey: 'menu.attendanceCard', path: '/pdks-reports/attendance-card', privileges: ['TA.Read'], moduleGated: true },
          { key: 'shift-report', labelKey: 'menu.shiftReport', path: '/pdks-reports/shift-report', privileges: ['TA.Read'], moduleGated: true },
          { key: 'plan-vs-actual-report', labelKey: 'menu.planVsActualReport', path: '/pdks-reports/plan-vs-actual', privileges: ['TA.Read'], moduleGated: true },
          { key: 'overtime-policies', labelKey: 'menu.overtimePolicies', path: '/overtime-policies', privileges: ['TA.Write'], moduleGated: true },
          { key: 'payroll-summary', labelKey: 'menu.payrollSummary', path: '/payroll-summary', privileges: ['TA.Read'], moduleGated: true },
        ],
      },
      {
        key: 'shift-management',
        labelKey: 'menu.shiftManagement',
        icon: CalendarClock,
        privileges: ['SM.Read'],
        moduleGated: true,
        children: [
          { key: 'shift-schedules', labelKey: 'menu.shiftSchedules', path: '/shift-schedules', privileges: ['SM.Read'] },
          { key: 'shift-rotations', labelKey: 'menu.shiftRotations', path: '/shift-rotations', privileges: ['SM.Read'] },
          // AKM POC §6.3 / §6.5 — vardiya ayarları: uyum profilleri ve nöbet izni kuralları (yazma ekranı, SM.Write).
          { key: 'compliance-profiles', labelKey: 'menu.complianceProfiles', path: '/compliance-profiles', privileges: ['SM.Write'], moduleGated: true },
          { key: 'duty-leave-rules', labelKey: 'menu.dutyLeaveRules', path: '/duty-leave-rules', privileges: ['SM.Write'], moduleGated: true },
        ],
      },
      {
        key: 'access-control',
        labelKey: 'menu.accessControl',
        icon: Shield,
        privileges: ['AC.Read'],
        moduleGated: true,
        children: [
          { key: 'buildings', labelKey: 'menu.buildings', path: '/buildings', privileges: ['AC.Read'] },
          { key: 'gates', labelKey: 'menu.gates', path: '/gates', privileges: ['AC.Read'] },
          { key: 'access-points', labelKey: 'menu.accessPoints', path: '/access-points', privileges: ['AC.Read'] },
          { key: 'gate-groups', labelKey: 'menu.gateGroups', path: '/gate-groups', privileges: ['AC.Read'] },
          { key: 'access-permissions', labelKey: 'menu.accessPermissions', path: '/access-permissions', privileges: ['AC.Write'] },
          { key: 'movement-records', labelKey: 'menu.movementRecords', path: '/movement-records', privileges: ['AC.Read'] },
          { key: 'unauthorized-access', labelKey: 'menu.unauthorizedAccess', path: '/unauthorized-access', privileges: ['AC.Write'] },
        ],
      },
    ],
  },
  // ---- Yaşam Döngüsü kategorisi (işe alım → işten ayrılış) ----
  {
    key: 'cat-lifecycle',
    labelKey: 'menu.catLifecycle',
    icon: Rocket,
    variant: 'category',
    privileges: [],
    children: [
      {
        // ATS (AT) — recruitment funnel from requisition through hire.
        key: 'ats',
        labelKey: 'menu.ats',
        icon: UserSearch,
        privileges: ['AT.Read'],
        moduleGated: true,
        children: [
          { key: 'ats-dashboard', labelKey: 'menu.atsDashboard', path: '/ats/dashboard', privileges: ['AT.Read', 'AT.Write'] },
          { key: 'ats-reports', labelKey: 'menu.atsReports', path: '/ats/reports', privileges: ['AT.Read', 'AT.Write'] },
          { key: 'ats-requisitions', labelKey: 'menu.atsRequisitions', path: '/ats/requisitions', privileges: ['AT.Read'] },
          { key: 'ats-job-postings', labelKey: 'menu.atsJobPostings', path: '/ats/job-postings', privileges: ['AT.Read'] },
          { key: 'ats-candidates', labelKey: 'menu.atsCandidates', path: '/ats/candidates', privileges: ['AT.Read'] },
          // Aday Havuzu (SPEC F2) — havuzlar tüm adayları içerir: YALNIZ AT.Write.
          { key: 'ats-candidate-pools', labelKey: 'menu.atsCandidatePools', path: '/ats/candidate-pools', privileges: ['AT.Write'] },
          { key: 'ats-applications', labelKey: 'menu.atsApplications', path: '/ats/applications', privileges: ['AT.Read'] },
          { key: 'ats-interviews', labelKey: 'menu.atsInterviews', path: '/ats/interviews', privileges: ['AT.Read'] },
          { key: 'ats-scorecards', labelKey: 'menu.atsScorecards', path: '/ats/scorecards', privileges: ['AT.Read'] },
          { key: 'ats-offers', labelKey: 'menu.atsOffers', path: '/ats/offers', privileges: ['AT.Read'] },
          { key: 'ats-settings', labelKey: 'menu.atsSettings', path: '/ats/settings', privileges: ['AT.Write'] },
        ],
      },
      {
        // Preboarding (PB) — bridges accepted offer to first day on the job.
        // my-preboarding burada kalır: isPreboardingLocked mekanizması onu yönetir (karar #3).
        key: 'preboarding',
        labelKey: 'menu.preboarding',
        icon: Sparkles,
        privileges: ['PB.Read'],
        moduleGated: true,
        children: [
          { key: 'my-preboarding', labelKey: 'menu.myPreboarding', path: '/my-preboarding', privileges: [] },
          { key: 'preboardings', labelKey: 'menu.preboardings', path: '/preboardings', privileges: ['PB.Read'] },
          { key: 'preboarding-tasks', labelKey: 'menu.preboardingTasks', path: '/preboardings/tasks', privileges: ['PB.Read'] },
          { key: 'preboarding-documents', labelKey: 'menu.preboardingDocuments', path: '/preboardings/documents', privileges: ['PB.Read'] },
          { key: 'preboarding-noshow-signals', labelKey: 'menu.preboardingNoShowSignals', path: '/preboardings/noshow-signals', privileges: ['PB.Read'] },
          { key: 'preboarding-task-templates', labelKey: 'menu.preboardingTaskTemplates', path: '/preboardings/task-templates', privileges: ['PB.Read'] },
        ],
      },
      {
        // Onboarding (OB) — first day → 90 day; emits E7/E8/E9/E10.
        // my-onboarding burada kalır (karar #3); onboarding-period-approvals → Onaylarım.
        key: 'onboarding',
        labelKey: 'menu.onboarding',
        icon: Rocket,
        privileges: ['OB.Read'],
        moduleGated: true,
        children: [
          { key: 'my-onboarding', labelKey: 'menu.myOnboarding', path: '/my-onboarding', privileges: [] },
          // Yönetici Paneli: yalnız en az bir süreçte Manager/Buddy atanmış kullanıcıda
          // görünür (hasTeamOnboardings — nonmanagerial çalışan görmez, müşteri isteği).
          { key: 'my-team-onboarding', labelKey: 'menu.myTeamOnboarding', path: '/my-team-onboarding', privileges: [], requiresUserFlag: 'hasTeamOnboardings' },
          { key: 'onboardings', labelKey: 'menu.onboardings', path: '/onboarding', privileges: ['OB.Read'] },
          { key: 'onboarding-task-templates', labelKey: 'menu.onboardingTaskTemplates', path: '/onboarding/task-templates', privileges: ['OB.Read'] },
          { key: 'onboarding-surveys', labelKey: 'menu.onboardingSurveys', path: '/onboarding/surveys', privileges: ['OB.Read'] },
          { key: 'onboarding-one-on-ones', labelKey: 'menu.onboardingOneOnOnes', path: '/onboarding/one-on-ones', privileges: ['OB.Read'] },
          { key: 'onboarding-goals', labelKey: 'menu.onboardingGoals', path: '/onboarding/goals', privileges: ['OB.Read'] },
          { key: 'onboarding-trainings', labelKey: 'menu.onboardingTrainings', path: '/onboarding/trainings', privileges: ['OB.Read'] },
          { key: 'onboarding-risk-watch', labelKey: 'menu.onboardingRiskWatch', path: '/onboarding/risk-watch', privileges: ['OB.Read'] },
        ],
      },
      {
        // Offboarding (OD) — exit lifecycle; emits E11/E12/E13/E15.
        // my-offboarding burada kalır (karar #3).
        key: 'offboarding',
        labelKey: 'menu.offboarding',
        icon: LogOut,
        privileges: ['OD.Read'],
        moduleGated: true,
        children: [
          // "İşten Ayrılışım" yalnız DEVAM EDEN bir ayrılış süreci olan çalışana
          // görünür (müşteri geri bildirimi). Süreci yoksa öğe — ve grupta başka
          // görünür çocuğu kalmayan çalışanda tüm İşten Ayrılış menüsü — gizlenir.
          { key: 'my-offboarding', labelKey: 'menu.myOffboarding', path: '/my-offboarding', privileges: [], requiresUserFlag: 'hasActiveOffboarding' },
          { key: 'offboardings', labelKey: 'menu.offboardings', path: '/offboarding', privileges: ['OD.Read'] },
          { key: 'offboarding-it-access', labelKey: 'menu.offboardingItAccess', path: '/offboarding/it-access', privileges: ['OD.Read'] },
          { key: 'offboarding-equipment', labelKey: 'menu.offboardingEquipment', path: '/offboarding/equipment', privileges: ['OD.Read'] },
          { key: 'offboarding-handovers', labelKey: 'menu.offboardingHandovers', path: '/offboarding/handovers', privileges: ['OD.Read'] },
          { key: 'offboarding-legal-docs', labelKey: 'menu.offboardingLegalDocs', path: '/offboarding/legal-docs', privileges: ['OD.Read'] },
          { key: 'offboarding-exit-interviews', labelKey: 'menu.offboardingExitInterviews', path: '/offboarding/exit-interviews', privileges: ['OD.Read'] },
          { key: 'offboarding-alumni', labelKey: 'menu.offboardingAlumni', path: '/offboarding/alumni', privileges: ['OD.Read'] },
          { key: 'offboarding-security-audit', labelKey: 'menu.offboardingSecurityAudit', path: '/offboarding/security-audit', privileges: ['OD.Read'] },
          { key: 'offboarding-task-templates', labelKey: 'menu.offboardingTaskTemplates', path: '/offboarding/task-templates', privileges: ['OD.Read'] },
        ],
      },
    ],
  },
  // ---- Performans & Gelişim kategorisi ----
  {
    key: 'cat-performans',
    labelKey: 'menu.catPerformanceDev',
    icon: Target,
    variant: 'category',
    privileges: [],
    children: [
      {
        // Task 37 — PRD cutover: eski Performans Yönetimi çekirdeği (Döngüler,
        // Yetkinlikler, Yetkinlik Setleri, Şablonlar, eski Hedef Yönetimi/
        // Değerlendirmeler/Kalibrasyon/Raporlar/Panel) menüden çıkarıldı; yerini
        // Tasks 25-33'te inşa edilen PRD ekranları alır. Eski rotalar Task 38
        // söküm (cutover) migration'ına dek canlı kalır — yalnız menü bağı kesildi.
        // `module: 'PM'` — SidebarMenu.hasAccess artık moduleGated kodunu
        // privileges[0]'dan çıkarmak yerine (varsa) bu alandan okuyor (bkz.
        // menuTree.moduleGateCode) — Faz A'nın TD grubunda kurduğu `module`
        // alanı deseniyle hizalandı (ledger T9).
        key: 'performance-management',
        labelKey: 'menu.performanceManagement',
        icon: Target,
        privileges: ['PM.Read'],
        // Faz 3 / PM-01+PM-06 — GRUBUN KENDİSİ de OR-kapılı olmalı: children'a
        // `orUserFlag` eklemek TEK BAŞINA yetmez, çünkü filterAccessible önce
        // GRUBU eler (menuTree.filterAccessible: "gate the group") ve PM.Read'i
        // olmayan amirde grup düşerse altındaki iki yönetici girdisi hiç
        // çizilmez. Envanterin "FE'de 1 yer" dediği kusurun gerçekte dört
        // yerde olmasının sebebi tam olarak budur. Hedef onay akışı onaycısı
        // (hasGoalFlowApprovals) da Ekip Hedefleri'ne buradan ulaşır.
        orUserFlag: ['hasSubordinates', 'hasGoalFlowApprovals'],
        moduleGated: true,
        module: 'PM',
        children: [
          { key: 'performance-periods', labelKey: 'menu.performancePeriods', path: '/performance/periods', privileges: ['PM.Read', 'PM.Write'] },
          // Faz 3 / PM-01 — `orUserFlag`: amirin hedef onayı/puanlama yüzeyi.
          // Backend kapısı artık İLİŞKİ (doğrudan rapor ∪ vekâlet ∪ İK), yani
          // PM izni olmayan amir de karar verebiliyor — menü onu göstermezse
          // düzeltme sessizce ölür. `privileges: []` yapmak DOĞRU DEĞİL: astı
          // olmayan 1000 çalışana kalıcı ölü bir menü girdisi açardı (TD-31'in
          // aynı kusuru). OR-kapısı deseni leave-balance-report'tan geliyor.
          { key: 'performance-team-goals', labelKey: 'menu.goalManagement', path: '/performance/team-goals', privileges: ['PM.Read', 'PM.Write'], orUserFlag: ['hasSubordinates', 'hasGoalFlowApprovals'] },
          { key: 'performance-evaluator-approvals', labelKey: 'menu.evaluatorApprovals', path: '/performance/evaluator-approvals', privileges: ['PM.Write'] },
          { key: 'performance-team-calibration', labelKey: 'menu.calibration', path: '/performance/team-calibration', privileges: ['PM.Write'] },
          // Faz B (spec 2026-08-07 §4, Task 5) — moderatörlü kalibrasyon
          // oturumları (ızgara + gerekçeli taşıma + kapanış). Kalibrasyon'un
          // ALTINA eklendi (brief); PM.Read yeterli (List/GetById/Grid sınıf
          // düzeyi PM.Read — Create/Activate/Cancel/Delete PM.Write servis
          // katmanında + sayfa içinde canWrite('PM') ile ayrıca gate'lenir).
          { key: 'performance-calibration-sessions', labelKey: 'menu.calibrationSessions', path: '/performance/calibration-sessions', privileges: ['PM.Read'] },
          // Faz G (spec 2026-08-08 §3/§4, Task 4) — Ücret Artış Turu: tek
          // sayfa iki sekme (İK canWrite('PM') / Ekibim self-servis). PM.Read
          // yeterli (route/menü TABANI — İK/Ekibim ayrımı sayfa İÇİNDE,
          // performance-calibration-sessions'ın AYNI deseni).
          // Faz 3 / PM-06 — aynı OR-kapısı: ücret önerisi "Ekibim" sekmesi
          // self-servistir (CompCycleMyTeamController [Authorize]-only), ama
          // menü PM.Read istiyordu ve zam turunda 140 amirin menüsünde giriş
          // çıkmıyordu.
          { key: 'performance-comp-cycles', labelKey: 'menu.compCycles', path: '/performance/comp-cycles', privileges: ['PM.Read'], orUserFlag: 'hasSubordinates' },
          // Faz D Task 4/5'in 1:1 Görüşmelerim + Takdir girişleri BURADAN
          // "Benim > Gelişimim"e TAŞINDI (F2 düzeltmesi, whole-branch review
          // — bkz. `benim` grubundaki `feedback-my`'ın hemen altı). Gerekçe
          // orada.
          // Ekibim-yüzeyi kararı: menüde ayrı bir "Benim > Ekibim" alt-grubu
          // yok (bkz. MenuConfig.test.js), bu yüzden feedback/team + feedback/all
          // (Task 31) PM grubuna eklendi — ikisi de zaten PM.Read gerektiren
          // yönetim/İK yüzeyleri (route privileges'i ile birebir).
          { key: 'performance-team-feedback', labelKey: 'menu.teamFeedback', path: '/feedback/team', privileges: ['PM.Read'] },
          { key: 'performance-all-feedback', labelKey: 'menu.allFeedback', path: '/feedback/all', privileges: ['PM.Read'] },
          // Skorlama Plan 4, Task 4 (task-4-brief.md) — Kurumsal Hedefler (OrgGoal:
          // company/department/team hedef ağacı). performance-tasks'ın ÜSTÜNE
          // eklendi (brief'in konum talimatı) — moduleGated PARENT'a güveniyor
          // (children kendi moduleGated'ini taşımaz, hrAnalytics/leave-management
          // ile AYNI desen).
          { key: 'performance-org-goals', labelKey: 'menu.orgGoals', path: '/performance/org-goals', privileges: ['PM.Read'] },
          { key: 'performance-tasks', labelKey: 'menu.performanceTasks', path: '/performance/tasks', privileges: ['PM.Read'] },
          // P1 parite paketi (2026-08-04): PIP süreçleri + sonuç itiraz kuyruğu.
          // Görev 26 (B5) — requiresHr (İK rolü ayrımı; eskiden requiresEnterpriseAdmin): PMB-08'de bu iki ucun OKUMA
          // kapsamı İK'ya (aktif enterpriseAdmin) daraltıldı; PM.Read'i olan ama
          // İK olmayan bir kullanıcı menüyü görüp KALICI OLARAK BOŞ bir listeye
          // düşüyordu (kapı doğru, menü yalancı). Sayfa-içi İK ayrımının
          // (CompCyclesPage / DelegationsTab: canWrite('PM') && isEnterpriseAdmin)
          // menü karşılığı. superAdmin muaf — hasAccess'te önce döner.
          { key: 'performance-pips', labelKey: 'menu.pipProcesses', path: '/performance/pips', privileges: ['PM.Read'], requiresHr: true },
          { key: 'performance-objections', labelKey: 'menu.resultObjections', path: '/performance/objections', privileges: ['PM.Read'], requiresHr: true },
          // Analitik Plan 4 — bulgular + aksiyonlar İK menüsünde; sorumlu Aksiyonlar sayfasına Gelen Kutum'dan gelir
          // (her çalışana boş bir menü kalemi gösterilmez).
          { key: 'performance-insights', labelKey: 'menu.performanceInsights', path: '/performance/insights', privileges: ['PM.Read'], requiresHr: true },
          { key: 'performance-actions', labelKey: 'menu.performanceActions', path: '/performance/actions', privileges: ['PM.Read'], requiresHr: true },
          // Analitik Plan 3 (spec §5.4) — İK VEYA astı olan; PM.Read tek başına yetki DEĞİL (rapor uçları 403).
          { key: 'performance-settings', labelKey: 'menu.performanceSettings', path: '/performance/settings', privileges: ['PM.Write'] },
          // Toplu kurulum: yetkinlik kütüphanesi, puanlama skalası, hedef
          // şablonları, pozisyon yetkinlikleri ve kişi hedefleri tek Excel ile.
          { key: 'performance-import', labelKey: 'menu.performanceImport', path: '/performance/import', privileges: ['PM.Write'] },
          // PM analitik Faz 3 (analiz A5) — geçmiş dönem sonuçlarının Excel ile içe aktarılması; yalnız İK.
          { key: 'performance-history-import', labelKey: 'menu.performanceHistoryImport', path: '/performance/history-import', privileges: ['PM.Read'], requiresHr: true },
        ],
      },
      {
        // PM analitik Faz 2-5 (2026-10-08) — analizin E01-E16/E19 ekranları tek grupta. Kapı Performans Yönetimi grubuyla AYNI:
        // PM.Read ya da astı olan (filterAccessible önce grubu eler); her yaprak kendi kapsamını taşır — İK'ya özgüler
        // requiresHr (rota da), İK + yönetici yüzeyleri hrOrUserFlag (PM.Read tek başına yetki değil, uç 403 döner).
        key: 'performance-analytics',
        labelKey: 'menu.performanceAnalytics',
        icon: BarChart3,
        privileges: ['PM.Read'],
        orUserFlag: 'hasSubordinates',
        moduleGated: true,
        module: 'PM',
        children: [
          { key: 'performance-executive', labelKey: 'menu.performanceExecutive', path: '/performance/executive', privileges: ['PM.Read'], requiresHr: true },
          // Faz 3 / PM-09 — requiresHr: panel kiracı geneli toplulaştırma verir ve BE İK'ya kapılı (HrActorRules).
          { key: 'performance-dashboard-hr', labelKey: 'menu.performanceOperations', path: '/performance/operations', privileges: ['PM.Read'], requiresHr: true },
          // Faz 2 Plan 4 (spec §7.1, §10) — E02 Süreç Takibi: gecikmenin görevi ve sorumlusu; yalnız İK.
          { key: 'performance-process-health', labelKey: 'menu.performanceProcessHealth', path: '/performance/process-health', privileges: ['PM.Read'], requiresHr: true },
          { key: 'performance-results', labelKey: 'menu.performanceResults', path: '/performance/results', privileges: [], module: 'PM', hrOrUserFlag: 'hasSubordinates' },
          { key: 'performance-org-comparison', labelKey: 'menu.performanceOrgComparison', path: '/performance/org-comparison', privileges: ['PM.Read'], requiresHr: true },
          { key: 'performance-trends', labelKey: 'menu.performanceTrends', path: '/performance/trends', privileges: [], module: 'PM', hrOrUserFlag: 'hasSubordinates' },
          { key: 'performance-goal-analytics', labelKey: 'menu.performanceGoalAnalytics', path: '/performance/goal-analytics', privileges: [], module: 'PM', hrOrUserFlag: 'hasSubordinates' },
          { key: 'performance-competency-gaps', labelKey: 'menu.performanceCompetencyGaps', path: '/performance/competency-gaps', privileges: [], module: 'PM', hrOrUserFlag: 'hasSubordinates' },
          { key: 'performance-review-gaps', labelKey: 'menu.performanceReviewGaps', path: '/performance/review-gaps', privileges: [], module: 'PM', hrOrUserFlag: 'hasSubordinates' },
          { key: 'performance-rater-behavior', labelKey: 'menu.performanceRaterBehavior', path: '/performance/rater-behavior', privileges: ['PM.Read'], requiresHr: true },
          { key: 'performance-development-analytics', labelKey: 'menu.performanceDevelopmentAnalytics', path: '/performance/development-analytics', privileges: [], module: 'PM', hrOrUserFlag: 'hasSubordinates' },
          { key: 'performance-feedback-analytics', labelKey: 'menu.performanceFeedbackAnalytics', path: '/performance/feedback-analytics', privileges: [], module: 'PM', hrOrUserFlag: 'hasSubordinates' },
          { key: 'performance-experience', labelKey: 'menu.performanceExperience', path: '/performance/experience', privileges: [], module: 'PM', hrOrUserFlag: 'hasSubordinates' },
          { key: 'performance-ai-center', labelKey: 'menu.performanceAiCenter', path: '/performance/ai-center', privileges: [], module: 'PM', hrOrUserFlag: 'hasSubordinates' },
          { key: 'performance-report-center', labelKey: 'menu.performanceReportCenter', path: '/performance/report-center', privileges: [], module: 'PM', hrOrUserFlag: 'hasSubordinates' },
        ],
      },
      {
        // Yetenek & Gelişim (TD) — abone olmayan tenant'ta grup KİLİTLİ görünür
        // (lockedWhenUnsubscribed): çocuklar gizlenir, tıklama /talent/upsell açar.
        // Desen yalnız bu gruba uygulanır (bkz. menuTree.lockGated). `module: 'TD'`
        // kilit kodunun kaynağıdır — privileges'tan çıkarım yapılmaz (bkz. menuTree.js).
        key: 'talent-development',
        labelKey: 'menu.talentDevelopment',
        icon: Star,
        privileges: ['TD.Read'],
        moduleGated: true,
        module: 'TD',
        lockedWhenUnsubscribed: true,
        children: [
          { key: 'talent-dashboard', labelKey: 'menu.talentDashboard', path: '/talent/dashboard', privileges: ['TD.Read'] },
          { key: 'talent-potential', labelKey: 'menu.potentialAssessments', path: '/talent/potential-assessments', privileges: ['TD.Read'] },
          { key: 'talent-ninebox', labelKey: 'menu.nineBox', path: '/talent/nine-box', privileges: ['TD.Read'] },
          { key: 'talent-ninebox-ratings', labelKey: 'menu.nineBoxRatings', path: '/talent/nine-box-ratings', privileges: ['TD.Write'] },
          // PM analitik E09 — dönemler arası 9-Box geçiş matrisi.
          { key: 'talent-ninebox-transitions', labelKey: 'menu.talentNineBoxTransitions', path: '/talent/nine-box-transitions', privileges: ['TD.Read'] },
          { key: 'talent-pool', labelKey: 'menu.talentPool', path: '/talent/pool', privileges: ['TD.Read'] },
          { key: 'talent-succession', labelKey: 'menu.succession', path: '/talent/succession', privileges: ['TD.Read'] },
          { key: 'talent-idp', labelKey: 'menu.developmentPlans', path: '/talent/development-plans', privileges: ['TD.Read'] },
          { key: 'talent-reports', labelKey: 'menu.talentReports', path: '/talent/reports', privileges: ['TD.Read'] },
          { key: 'talent-settings', labelKey: 'menu.talentSettings', path: '/talent/settings', privileges: ['TD.Write'] },
        ],
      },
      {
        key: 'training',
        labelKey: 'menu.training',
        icon: GraduationCap,
        privileges: ['TR.Read'],
        moduleGated: true,
        children: [
          { key: 'training-dashboard', labelKey: 'menu.trainingDashboard', path: '/training-dashboard', privileges: ['TR.Write'] },
          { key: 'trainings', labelKey: 'menu.trainings', path: '/trainings', privileges: ['TR.Write'] },
          { key: 'training-categories', labelKey: 'menu.trainingCategories', path: '/training-categories', privileges: ['TR.Write'] },
          { key: 'certificate-templates', labelKey: 'menu.certificateTemplates', path: '/certificate-templates', privileges: ['TR.Write'] },
          { key: 'training-assignment-rules', labelKey: 'menu.trainingAssignmentRules', path: '/training-assignment-rules', privileges: ['TR.Write'] },
          { key: 'training-audit', labelKey: 'menu.trainingAudit', path: '/training-audit', privileges: ['TR.Write'] },
          { key: 'training-reports', labelKey: 'menu.trainingReports', path: '/training-reports', privileges: ['TR.Write'] },
          // my-team-training, training-leaderboard Eğitim modülünde kalır (karar #4).
          { key: 'my-team-training', labelKey: 'menu.myTeamTraining', path: '/my-team-training', privileges: ['TR.Read'] },
          { key: 'training-leaderboard', labelKey: 'menu.trainingLeaderboard', path: '/training-leaderboard', privileges: ['TR.Read'] },
        ],
      },
    ],
  },
  // ---- İdari İşler kategorisi ----
  {
    key: 'cat-idari',
    labelKey: 'menu.catAdminOps',
    icon: Briefcase,
    variant: 'category',
    privileges: [],
    children: [
      {
        key: 'expense-management',
        labelKey: 'menu.expenseManagement',
        icon: Receipt,
        privileges: ['EX.Read'],
        moduleGated: true,
        children: [
          { key: 'expense-dashboard', labelKey: 'menu.expenseDashboard', path: '/expense-dashboard', privileges: ['EX.Write'] },
          { key: 'expense-reports', labelKey: 'menu.expenseReports', path: '/expense-reports', privileges: ['EX.Write'] },
          { key: 'expense-report-subscriptions', labelKey: 'menu.expenseReportSubs', path: '/expense-report-subscriptions', privileges: ['EX.Write'] },
          { key: 'expense-categories', labelKey: 'menu.expenseCategories', path: '/expense-categories', privileges: ['EX.Write'] },
          // Projeler — masrafın ilişkilendirildiği projeler (entegrasyon yok, elle kayıt).
          // Çalışanın girişteki seçicisi ayrı bir uçtan (options) beslenir; bu yönetim ekranı
          // kategori/bütçe ekranlarıyla aynı EX.Write kapısındadır.
          { key: 'expense-projects', labelKey: 'menu.expenseProjects', path: '/expense-projects', privileges: ['EX.Write'] },
          { key: 'expense-budgets', labelKey: 'menu.expenseBudgets', path: '/expense-budgets', privileges: ['EX.Write'] },
          { key: 'all-expenses', labelKey: 'menu.allExpenses', path: '/all-expenses', privileges: ['EX.Write'] },
        ],
      },
      {
        key: 'asset-management',
        labelKey: 'menu.assetManagement',
        icon: Package,
        privileges: ['AM.Read'],
        moduleGated: true,
        children: [
          { key: 'assets', labelKey: 'menu.assets', path: '/assets', privileges: ['AM.Write'] },
          { key: 'asset-assignments', labelKey: 'menu.assetAssignments', path: '/asset-assignments', privileges: ['AM.Write'] },
          { key: 'asset-categories', labelKey: 'menu.assetCategories', path: '/asset-categories', privileges: ['AM.Write'] },
          { key: 'asset-import', labelKey: 'menu.assetImport', path: '/asset-import', privileges: ['AM.Write'] },
        ],
      },
      {
        key: 'canteen',
        labelKey: 'menu.canteen',
        icon: Utensils,
        privileges: ['CN.Read'],
        moduleGated: true,
        children: [
          { key: 'meals', labelKey: 'menu.meals', path: '/meals', privileges: ['CN.Write'] },
          { key: 'meal-menus', labelKey: 'menu.mealMenus', path: '/meal-menus', privileges: ['CN.Write'] },
          { key: 'meal-entitlements', labelKey: 'menu.mealEntitlements', path: '/meal-entitlements', privileges: ['CN.Write'] },
          { key: 'meal-entries', labelKey: 'menu.mealEntries', path: '/meal-entries', privileges: ['CN.Write'] },
          { key: 'meal-statistics', labelKey: 'menu.mealStatistics', path: '/meal-statistics', privileges: ['CN.Write'] },
          { key: 'canteen-settings', labelKey: 'menu.canteenSettings', path: '/canteen-settings', privileges: ['CN.Write'] },
        ],
      },
      {
        key: 'visitor-management',
        labelKey: 'menu.visitorManagement',
        icon: IdCard,
        privileges: ['VM.Read'],
        moduleGated: true,
        children: [
          { key: 'visits', labelKey: 'menu.visits', path: '/visits', privileges: ['VM.Read'] },
        ],
      },
    ],
  },
  // ---- Bağlılık & Deneyim kategorisi ----
  {
    key: 'cat-deneyim',
    labelKey: 'menu.catEngagement',
    icon: Heart,
    variant: 'category',
    privileges: [],
    children: [
      {
        key: 'benefits',
        labelKey: 'menu.benefits',
        icon: Gift,
        privileges: ['BN.Read'],
        moduleGated: true,
        children: [
          { key: 'benefit-dashboard', labelKey: 'menu.benefitDashboard', path: '/benefit-dashboard', privileges: ['BN.Write'] },

          { key: 'benefit-categories', labelKey: 'menu.benefitCategories', path: '/benefit-categories', privileges: ['BN.Write'] },
          { key: 'benefits-list', labelKey: 'menu.benefitsList', path: '/benefits', privileges: ['BN.Write'] },
          { key: 'benefit-packages', labelKey: 'menu.benefitPackages', path: '/benefit-packages', privileges: ['BN.Write'] },
          { key: 'seniority-budget-tiers', labelKey: 'menu.seniorityBudgetTiers', path: '/seniority-budget-tiers', privileges: ['BN.Write'] },

          { key: 'benefit-dependents', labelKey: 'menu.benefitDependents', path: '/benefit-dependents', privileges: ['BN.Write'] },
          { key: 'benefit-applications', labelKey: 'menu.benefitApplications', path: '/benefit-applications', privileges: ['BN.Write'] },
          { key: 'life-events', labelKey: 'menu.lifeEvents', path: '/life-events', privileges: ['BN.Write'] },

          { key: 'open-enrollment-periods', labelKey: 'menu.openEnrollmentPeriods', path: '/open-enrollment-periods', privileges: ['BN.Write'] },
          { key: 'cafeteria-pools', labelKey: 'menu.cafeteriaPools', path: '/cafeteria-pools', privileges: ['BN.Write'] },
          { key: 'cafeteria-selections', labelKey: 'menu.cafeteriaSelections', path: '/cafeteria-selections', privileges: ['BN.Write'] },

          { key: 'benefit-reports', labelKey: 'menu.benefitReports', path: '/benefit-reports', privileges: ['BN.Write'] },
          { key: 'benefit-audit-logs', labelKey: 'menu.benefitAuditLogs', path: '/benefit-audit-logs', privileges: ['BN.Write'] },
        ],
      },
      {
        key: 'surveys',
        labelKey: 'menu.surveys',
        icon: ClipboardList,
        privileges: ['SV.Read'],
        moduleGated: true,
        children: [
          { key: 'survey-list', labelKey: 'menu.surveyList', path: '/surveys', privileges: ['SV.Read'] },
          { key: 'public-survey-dashboard', labelKey: 'menu.publicSurveyDashboard', path: '/public-survey-dashboard', privileges: ['superAdmin'] },
        ],
      },
      {
        key: 'announcements',
        labelKey: 'menu.announcements',
        icon: Megaphone,
        privileges: ['AN.Read'],
        children: [
          { key: 'manage-announcements', labelKey: 'menu.manageAnnouncements', path: '/announcements', privileges: ['AN.Write'] },
        ],
      },
      {
        key: 'raffles',
        labelKey: 'menu.raffles',
        icon: Ticket,
        privileges: ['RF.Read'],
        children: [
          { key: 'manage-raffles', labelKey: 'menu.manageRaffles', path: '/raffles', privileges: ['RF.Write'] },
        ],
      },
      {
        key: 'ethics-compliance',
        labelKey: 'menu.ethicsCompliance',
        icon: ShieldCheck,
        privileges: ['ET.Read'],
        moduleGated: true,
        children: [
          { key: 'policy-documents', labelKey: 'menu.policyDocuments', path: '/policy-documents', privileges: ['ET.Write'] },
          { key: 'ethics-reports-admin', labelKey: 'menu.ethicsReportsAdmin', path: '/ethics-reports', privileges: ['ET.Write'] },
          { key: 'ethics-report-categories', labelKey: 'menu.ethicsReportCategories', path: '/ethics-report-categories', privileges: ['ET.Write'] },
        ],
      },
      {
        key: 'important-links',
        labelKey: 'menu.importantLinks',
        icon: Link2,
        privileges: ['IL.Read'],
        children: [
          { key: 'manage-links', labelKey: 'menu.manageLinks', path: '/important-links', privileges: ['IL.Write'] },
        ],
      },
    ],
  },
  // ---- Sistem kategorisi (footer) ----
  {
    key: 'cat-sistem',
    labelKey: 'menu.catSystem',
    icon: Settings,
    variant: 'category',
    privileges: [],
    isFooter: true,
    children: [
      {
        key: 'organization',
        labelKey: 'menu.organization',
        icon: Building2,
        privileges: ['EM.Write'],
        isFooter: true,
        children: [
          {
            key: 'locations',
            labelKey: 'menu.locations',
            path: '/locations',
            privileges: ['EM.Write'],
          },
          {
            key: 'titles',
            labelKey: 'menu.titles',
            path: '/titles',
            privileges: ['EM.Write'],
          },
          // Personel Statüleri (AKM POC §6.1): memur (657) / işçi (4857) ayrımı — kural ataması ve
          // dinamik grup kriteri bu tanımlara bakar. Kapı ünvanlarınkiyle AYNI (EM.Write).
          {
            key: 'employee-statuses',
            labelKey: 'menu.employeeStatuses',
            path: '/employee-statuses',
            privileges: ['EM.Write'],
          },
          {
            key: 'job-grades',
            labelKey: 'menu.jobGrades',
            path: '/job-grades',
            privileges: ['EM.Write'],
          },
          {
            key: 'job-families',
            labelKey: 'menu.jobFamilies',
            path: '/job-families',
            privileges: ['EM.Write'],
          },
          {
            key: 'salary-bands',
            labelKey: 'menu.salaryBands',
            path: '/salary-bands',
            privileges: ['EM.Write'],
          },
          {
            key: 'departments',
            labelKey: 'menu.departments',
            path: '/departments',
            privileges: ['EM.Write'],
          },
          {
            key: 'positions',
            labelKey: 'menu.positions',
            path: '/positions',
            privileges: ['EM.Write'],
          },
          {
            key: 'user-groups',
            labelKey: 'menu.userGroups',
            path: '/user-groups',
            privileges: ['EM.Write'],
          },
          {
            key: 'roles',
            labelKey: 'menu.roles',
            path: '/roles',
            privileges: ['EM.Write'],
          },
          {
            key: 'approval-flows',
            labelKey: 'menu.approvalFlows',
            path: '/approval-flows',
            privileges: ['EM.Write'],
          },
          // Vekâletler onay akışının hemen ardında: akış "kim onaylar"ı, vekâlet
          // "o kişi yokken kim onaylar"ı söyler. Kapı akışlarınkiyle AYNI (EM.Write);
          // asıl yetki kapısı sunucudadır (İK — HrActorRules).
          {
            key: 'delegations',
            labelKey: 'menu.delegations',
            path: '/delegations',
            privileges: ['EM.Write'],
          },
          {
            key: 'work-hours',
            labelKey: 'menu.workHours',
            path: '/work-hours',
            privileges: ['EM.Write'],
          },
          {
            key: 'work-plans',
            labelKey: 'menu.workPlans',
            path: '/work-plans',
            privileges: ['EM.Write'],
          },
          // Şirket tatil takvimleri (AKM POC §5.4): kiracı kendi takvimini oluşturur ya da hazır şablonu
          // kopyalar. Aynı sayfa aşağıda superAdmin'in küresel şablon girişi olarak da durur (bilinçli çift yol).
          // `hiddenForSuperAdmin`: superAdmin tüm kontrolleri baypas ettiği için iki girişi birden görüyordu
          // (inceleme M13b) — superAdmin yalnız kendi platform girişini görür (menuTree.superAdminHiddenGate).
          {
            key: 'company-holiday-calendars',
            labelKey: 'menu.holidayCalendars',
            path: '/holiday-calendars',
            privileges: ['EM.Write'],
            hiddenForSuperAdmin: true,
          },
        ],
      },
      {
        key: 'company-settings',
        labelKey: 'menu.companySettings',
        icon: SlidersHorizontal,
        path: '/company-settings',
        privileges: ['EM.Write'],
        isFooter: true,
      },
      // Modül Bazlı Lisanslama (Görev 17): EM (varsayılan modül) altında —
      // moduleGated KONMAZ, lisans yönetimi her kiracıda görünür olmalıdır.
      {
        key: 'licenses',
        labelKey: 'menu.licenses',
        icon: Key,
        path: '/licenses',
        privileges: ['EM.Write'],
        // Kü-5 — `isFooter` KALDIRILDI: SidebarMenu bu ayrımı YALNIZ KÖK dizide yapıyor
        // (`searchedConfig.filter((item) => !item.isFooter)`), bu girdi ise `cat-sistem`
        // grubunun ÇOCUĞU — alan hiç okunmuyordu (company-settings'ten kopyalanmış ölü alan).
      },
      // Entegrasyonlar (Public API Plan 01, Görev 8 + Plan 03): API anahtarları ve webhook
      // yönetimi. PA varsayılan modül DEĞİL → `moduleGated: true` ZORUNLU:
      // enterpriseAdmin joker izniyle atlayamaz, kiracı PA'ya abone değilse öğe hiç görünmez.
      {
        key: 'integrations',
        labelKey: 'menu.integrations',
        icon: Plug,
        path: '/integrations',
        privileges: ['PA.Read'],
        moduleGated: true,
      },
      // Kurumsal Giriş (SSO) — YALNIZ kurum yöneticisi: bağlantıyı değiştiren alan adındaki herkesin girişini
      // yönlendirebilir (spec §10.1). `requiresEnterpriseAdmin` EM.Write sahibini dışarıda tutar.
      {
        key: 'sso-settings',
        labelKey: 'menu.ssoSettings',
        icon: KeyRound,
        path: '/settings/sso',
        privileges: ['enterpriseAdmin'],
        requiresEnterpriseAdmin: true,
      },
      // İşlem Geçmişi — YALNIZ şirket yöneticisi (AKM POC §9.1): kimin neyi ne zaman değiştirdiği / gördüğü / dışa aktardığı.
      {
        key: 'audit-logs',
        labelKey: 'menu.auditLogs',
        icon: ScrollText,
        path: '/audit-logs',
        privileges: ['enterpriseAdmin'],
        requiresEnterpriseAdmin: true,
      },
      {
        key: 'tenants',
        labelKey: 'menu.tenants',
        icon: Building2,
        path: '/tenants',
        privileges: ['tenant.manage'],
      },
      {
        key: 'holiday-calendars',
        labelKey: 'menu.holidayCalendars',
        icon: Calendar,
        path: '/holiday-calendars',
        privileges: ['superAdmin'],
        isFooter: true,
      },
      {
        key: 'sso-domains',
        labelKey: 'menu.ssoDomains',
        icon: Globe,
        path: '/admin/sso-domains',
        privileges: ['superAdmin'],
        isFooter: true,
      },
      // İzin Politikası Şablonları (Görev 5, 2026-08-30): ülke bazlı izin
      // politikası kalıpları, tenant açılışında kopyalanır. holiday-calendars
      // ile AYNI desen — global (TenantId yok), superAdmin'e kilitli.
      {
        key: 'leave-policy-templates',
        labelKey: 'menu.leavePolicyTemplates',
        icon: ScrollText,
        path: '/leave-policy-templates',
        privileges: ['superAdmin'],
        isFooter: true,
      },
      {
        // Lifecycle (AT/PB/OB/OD) admin oversight. Visible to enterprise admin and
        // superAdmin (no module privilege required — this is platform infra).
        key: 'lifecycle-admin',
        labelKey: 'menu.lifecycleAdmin',
        icon: Activity,
        privileges: ['superAdmin'],
        isFooter: true,
        children: [
          {
            key: 'lifecycle-events',
            labelKey: 'menu.lifecycleEvents',
            path: '/lifecycle-events',
            privileges: ['superAdmin'],
          },
          {
            key: 'lifecycle-persons',
            labelKey: 'menu.lifecyclePersons',
            path: '/lifecycle-persons',
            privileges: ['superAdmin'],
          },
          {
            key: 'kvkk-consents',
            labelKey: 'menu.kvkkConsents',
            path: '/kvkk-consents',
            privileges: ['superAdmin'],
          },
          {
            key: 'magic-link-tokens',
            labelKey: 'menu.magicLinkTokens',
            path: '/magic-link-tokens',
            privileges: ['superAdmin'],
          },
        ],
      },
    ],
  },
];

export default menuConfig;
